import { lazyLoad } from 'utils/lazy';

export const Encashments = lazyLoad(
  () => import('./Encash'),
  (m) => m.Encashments
);
